const PasswordResetSent = () => {
  return (
    <div className="full-width-container ">
      <div className="floating-box login-container mb-4">
        <h1 className="floating-box-header d-flex flex-row justify-content-center">
          <span className="mt-1">Reset Requested</span>
        </h1>
        <span className="completed positions"></span>
        <div className="flex-d sub-heading m-3 mt-0">
          Password Reset has been requested. Please now check your email inbox/spam folder for reset email link. You can
          close this browser screen as the email link will redirect to us.
        </div>
      </div>
    </div>
  );
};

export default PasswordResetSent;
